export default __webpack_public_path__ + "ac4549e.png";